import Vue from "vue";

import "./search-table.jsx"
import "./search-input.jsx"
Vue.component("k-packing", () => import('./packing'));
Vue.component("k-high-search", () => import('./high-search'));
Vue.component("k-high-search-item", () => import('./high-search-item'));
Vue.component("k-view-modal", () => import('./view-modal'));

// Vue.component("k-search-table", () => import('./search-table'));
